import React from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const InsightIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path
      d="M12 24a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm2 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm2-22c-3.83 0-7 3.046-7 7.5 0 2.744 1.942 4.267 3.409 5.03 1.038.54 1.924 1.626 1.924 2.977V21a1 1 0 1 1-2 0v-.493c0-.433-.303-.92-.847-1.202C9.792 18.424 7 16.378 7 12.5 7 7.013 10.994 3 16 3s9 4.013 9 9.5c0 4.062-2.573 6.017-4.342 6.858-.634.301-.991.837-.991 1.302V21a1 1 0 1 1-2 0v-.34c0-1.46 1.028-2.584 2.133-3.109C21.179 16.896 23 15.5 23 12.5 23 8.046 19.83 5 16 5Z"
      xmlns="http://www.w3.org/2000/svg"
    />
  </BaseIcon>
);
